import React from 'react';

import { OlStyled } from './Ol.style';

export const Ol = ({ children, ...props }: { children: any }) => {
  return <OlStyled {...props}>{children}</OlStyled>;
};
